<template>
    <div>
        <AppInput
            :name="errorLabel || name || label"
            :rules="rules"
            :label="label"
            v-slot="{errors, valid}"
            :row="row"
            :model-value="currentValue"
        >
            <v-text-field
                type="time"
                :model-value="currentValue"
                @update:model-value="onChange"
                label=""
                variant="outlined"
                density="compact"
                prepend-inner-icon="mdi-clock-outline"
                :disabled="disabled"
                :clearable="clearable"
                :error-messages="errors && errors.length > 0 ? [''] : []"
            ></v-text-field>
        </AppInput>
    </div>
</template>

<script>
import AppInput from "@/components/forms/AppInput";

export default {
    components: {AppInput},
    props: {
        modelValue: {
            required: false,
        },
        value: {
            required: false,
        },
        label: {
            required: true,
            type: String
        },
        placeholder: {
            type: String,
        },
        disabled: {
            type: Boolean
        },
        max: {},
        min: {},
        errorLabel: {},
        name: {
            type: String
        },
        rules: {},
        row: {
            type: Boolean
        },
        clearable: {
            type: Boolean
        }
    },
    emits: ['update:modelValue', 'input'],
    name: "AppFormTimePicker2",
    computed: {
        currentValue() {
            return this.modelValue !== undefined ? this.modelValue : this.value;
        }
    },
    methods: {
        onChange(value) {
            this.$emit('update:modelValue', value || null);
            this.$emit('input', value || null);
        }
    }
}
</script>

<style>
</style>
